// Compatibility re-export (BKPE-27795). See `features/observability/logger/utils`.
export * from 'features/observability/logger/utils';
